import { actionCreatorFactory } from 'typescript-fsa'
import { Trigger } from '../../types'

const actionCreator = actionCreatorFactory()

export const registerTriggers = actionCreator<Trigger[]>('registerTriggers')
